import React from 'react';

const WalletSelectionModal = ({ isOpen, onClose, onSelectWallet, availableWallets }) => {
  if (!isOpen) return null;

  // Detect if user is on mobile device
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // Reorder wallets to show WalletConnect first on mobile
  const orderedWallets = isMobile 
    ? [
        ...availableWallets.filter(w => w.type === 'walletconnect'),
        ...availableWallets.filter(w => w.type !== 'walletconnect')
      ]
    : availableWallets;

  const handleWalletSelect = (walletType) => {
    onSelectWallet(walletType);
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        backdropFilter: 'blur(5px)'
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'relative',
          background: 'linear-gradient(135deg, rgba(20, 20, 30, 0.95), rgba(40, 40, 60, 0.95))',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '20px',
          padding: isMobile ? '1rem' : '2rem',
          minWidth: isMobile ? '90vw' : '400px',
          maxWidth: isMobile ? '95vw' : '500px',
          maxHeight: isMobile ? '85vh' : '90vh',
          overflowY: 'auto',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          animation: 'modalSlideIn 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <style>
          {`
            @keyframes modalSlideIn {
              0% { 
                opacity: 0; 
                transform: scale(0.8) translateY(-20px);
              }
              100% { 
                opacity: 1; 
                transform: scale(1) translateY(0);
              }
            }
            
            .wallet-option {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding: ${isMobile ? '1rem' : '1.5rem'};
              margin: ${isMobile ? '0.75rem 0' : '1rem 0'};
              background: linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.1));
              border: 2px solid rgba(255, 255, 255, 0.1);
              border-radius: 15px;
              cursor: pointer;
              transition: all 0.3s ease;
              text-decoration: none;
              color: white;
              outline: none;
            }
            
            .wallet-option:hover {
              background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.15));
              border-color: rgba(255, 255, 255, 0.3);
              transform: translateY(-2px);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
            }
            
                         .wallet-icon {
               margin-right: ${isMobile ? '0.75rem' : '1rem'};
               min-width: ${isMobile ? '45px' : '60px'};
               display: flex;
               align-items: center;
               justify-content: center;
             }
             
             .wallet-icon img {
               width: ${isMobile ? '32px' : '40px'};
               height: ${isMobile ? '32px' : '40px'};
               object-fit: contain;
               border-radius: 8px;
               transition: transform 0.2s ease, filter 0.2s ease;
             }
             
             .wallet-option:hover .wallet-icon img {
               transform: scale(1.1);
               filter: brightness(1.1);
             }
            
            .wallet-info {
              text-align: left;
              flex: 1;
            }
            
            .wallet-name {
              font-size: ${isMobile ? '1rem' : '1.2rem'};
              font-weight: 700;
              margin-bottom: 0.3rem;
              color: white;
              display: flex;
              align-items: center;
              gap: 0.4rem;
              flex-wrap: wrap;
            }
            
            .device-icon {
              font-size: 1rem;
              opacity: 0.7;
            }
            
            .wallet-mini-icons {
              display: inline-flex;
              align-items: center;
              gap: 0.25rem;
              margin-left: 0.25rem;
            }
            
            .wallet-mini-icons img {
              width: ${isMobile ? '14px' : '16px'};
              height: ${isMobile ? '14px' : '16px'};
              object-fit: contain;
              border-radius: 3px;
              opacity: 0.8;
            }
            
            .recommended-badge {
              display: inline-flex;
              align-items: center;
              gap: 0.3rem;
              padding: ${isMobile ? '0.15rem 0.4rem' : '0.2rem 0.5rem'};
              background: linear-gradient(135deg, #10b981, #059669);
              color: white;
              font-size: ${isMobile ? '0.55rem' : '0.65rem'};
              font-weight: 700;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              border-radius: 4px;
              animation: pulse 2s ease-in-out infinite;
            }
            
            @keyframes pulse {
              0%, 100% {
                box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
              }
              50% {
                box-shadow: 0 0 0 4px rgba(16, 185, 129, 0);
              }
            }
            
            .wallet-description {
              font-size: ${isMobile ? '0.75rem' : '0.9rem'};
              color: rgba(255, 255, 255, 0.7);
              line-height: 1.3;
            }
            
            .wallet-option:focus {
              outline: none;
              border-color: rgba(255, 255, 255, 0.4);
            }
            
            .modal-close {
              position: absolute;
              top: 15px;
              right: 20px;
              background: none;
              border: none;
              color: rgba(255, 255, 255, 0.7);
              font-size: 1.5rem;
              cursor: pointer;
              transition: color 0.2s ease;
              outline: none;
            }
            
            .modal-close:hover {
              color: white;
            }
          `}
        </style>

        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <h2 style={{ 
          color: 'white', 
          marginBottom: isMobile ? '1rem' : '1.5rem', 
          fontSize: isMobile ? '1.2rem' : '1.5rem',
          fontWeight: '700'
        }}>
          Connect Your Wallet
        </h2>

        <p style={{ 
          color: 'rgba(255, 255, 255, 0.8)', 
          marginBottom: isMobile ? '1rem' : '2rem',
          fontSize: isMobile ? '0.85rem' : '0.95rem'
        }}>
          Choose your preferred wallet to connect to DOCTORdripp
        </p>



        <div>
          {orderedWallets.map((wallet) => (
            <div
              key={wallet.type}
              className="wallet-option"
              onClick={() => handleWalletSelect(wallet.type)}
            >
                             <div className="wallet-icon">
                 <img 
                   src={wallet.icon} 
                   alt={`${wallet.name} logo`}
                   onError={(e) => {
                     // Fallback to emoji if image fails to load
                     e.target.style.display = 'none';
                     e.target.parentNode.innerHTML = wallet.type === 'metamask' ? '🦊' : '🔵';
                   }}
                 />
               </div>
              <div className="wallet-info">
                <div className="wallet-name">
                  {wallet.name}
                  <span className="device-icon">
                    {wallet.type === 'walletconnect' ? '🖥️📱' : 
                     wallet.type === 'coinbase' ? '🖥️📱' : '🖥️'}
                  </span>
                  {wallet.type === 'walletconnect' && (
                    <span className="wallet-mini-icons">
                      <img src="/metamask.webp" alt="MetaMask" title="Supports MetaMask" />
                      <img src="/ledgerlive.webp" alt="Ledger Live" title="Supports Ledger Live" />
                    </span>
                  )}
                  {isMobile && wallet.type === 'walletconnect' && (
                    <span className="recommended-badge">
                      ✓ Recommended for Mobile
                    </span>
                  )}
                </div>
                <div className="wallet-description">
                  {wallet.type === 'metamask' 
                    ? 'Browser extension wallet' 
                    : wallet.type === 'rainbow'
                    ? 'Beautiful mobile wallet with native iOS & Android apps'
                    : wallet.type === 'magiceden'
                    ? wallet.installed === false 
                      ? 'Multi-chain wallet with NFT focus'
                      : 'Multi-chain wallet with NFT focus'
                    : wallet.type === 'walletconnect'
                    ? '300+ wallets including Ledger Live, Trust Wallet & more'
                    : wallet.type === 'coinbase'
                    ? 'Desktop extension & mobile app with QR code support'
                    : 'Mobile & desktop wallet with QR code support'}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p style={{ 
          color: 'rgba(255, 255, 255, 0.6)', 
          marginTop: isMobile ? '1rem' : '1.5rem',
          fontSize: isMobile ? '0.7rem' : '0.8rem',
          lineHeight: '1.4'
        }}>
          Don't have a wallet? Visit{' '}
          <a 
            href="https://metamask.io" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#FF6B35', textDecoration: 'none' }}
          >
            MetaMask
          </a>
          {' or use '}
          <a 
            href="https://walletconnect.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#3B99FC', textDecoration: 'none' }}
          >
            WalletConnect
          </a>
          {' to connect Coinbase, Rainbow, Magic Eden, Ledger & 300+ more wallets'}
        </p>
      </div>
    </div>
  );
};

export default WalletSelectionModal; 